import React from 'react';
const Row = ({
  location,
  own,
  accent_color
}) => /*#__PURE__*/React.createElement("div", {
  className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
  style: {
    '--accent-color': accent_color
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "location"
}, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", {
  className: "ranking-prefix"
}, location.ranking, "."), " ", location.location)), /*#__PURE__*/React.createElement("div", {
  className: "training-by-store-column"
}, /*#__PURE__*/React.createElement("div", {
  className: "training-by-store"
}, /*#__PURE__*/React.createElement("div", {
  className: "value"
}, /*#__PURE__*/React.createElement("b", null, location.value ? `${Math.round(location.value)}%` : '-')))));
export default Row;